import { fetchApi } from '@/config/axiosSetting';

import {
  GetBodyCustomerImageTabsAlertsQueryParamType,
  GetBodyCustomerImageTabsAlertsQueryResponseQueryType,
} from '@/modules/adjusterReportModules/Insurer-information/queries/getBodyCustomerImageTabsAlerts/getBodyCustomerImageTabsAlertsQuery.type';

export const getBodyCustomerImageTabsAlertsQueryFunctions = (
  params: GetBodyCustomerImageTabsAlertsQueryParamType,
): Promise<GetBodyCustomerImageTabsAlertsQueryResponseQueryType> =>
  fetchApi.get(`body/reports/${params.id}/images/customer/entry_tabs/alert/`);
